import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=5a18d8c4&"
import script from "./Homepage.js?vue&type=script&lang=js&"
export * from "./Homepage.js?vue&type=script&lang=js&"
import style0 from "./Homepage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports